import React, { useContext, useEffect, useState } from "react";
import { Pagination } from "antd";
import { crossDockService } from "../../../services/cross-dock.services";
import { deliveriesConfig } from "../../../config";
import Spinner from "../../spinner";
import { AppContext } from "../../../contexts/app-context";
import UserNotificationMessage from "../../user-message";
import NotificationMessage from "../../modals/notification-message";
import CrossDockGroupList from "../../cross-dock-group-list";
import CrossDockItemBlock from "../../cross-dock-item-block";
import CrossDockEmptyContent from "../../cross-dock-empty-content";


export default function CrossDockPage({ type = 'active' }) {

   const [step, setStep] = useState(deliveriesConfig.pageCount);
   const [offset, setOffset] = useState(0);
   const [currentPage, setCurrentPage] = useState(1);
   const [needUpdate, setNeedUpdate] = useState(true);
   const [data, setData] = useState(null);
   const [loadingScheduleItem, setLoadingScheduleItem] = useState(true);
   const [stopListUpdate, setStopListUpdate] = useState(false);
   const [notifications, setNotifications] = useState(null);
   const [error, setError] = useState(null);


   let loading = (data === null || needUpdate || (notifications === null && true));

   const appContext = useContext(AppContext);

   let onChange = (page, pageSize) => {
      if (page === currentPage) {
         return false;
      } else {
         setCurrentPage(page);
      }

      let val = 0;
      if (parseInt(page) === 1) {
         setOffset(0);
      } else {
         val = page * pageSize - pageSize;
         setOffset(val);
      }
      appContext.filter.offset = val;
      setNeedUpdate(true);
   };

   useEffect(() => {
      let isMounted = true;
      if (needUpdate || appContext.isNeedUpdateUnloadingList) {
         const request = type === 'archive' 
            ? crossDockService.getArchiveList(
                 offset,
                 step,
                 appContext.filter.selectedSorting
              )
            : crossDockService.getActualList(
                 offset,
                 step,
                 appContext.filter.selectedSorting
              );

         request
            .then((response) => {
               if (isMounted) {
                  if (response != null && response.CrossDocks.length > 0) {
                     response.CrossDocks = response.CrossDocks.map((entry) => {
                           return (
                              <CrossDockItemBlock key={`${entry.id}_${entry.status}`}
                                 crossDock={entry}
                                 setNeedUpdate={setNeedUpdate}
                                 setStopListUpdate={setStopListUpdate}
                              />
                           )
                        
                     })
                  }

                  setData(response)
                  setLoadingScheduleItem(false);
                  setNeedUpdate(false);
                  appContext.setIsNeedUpdateUnloadingList(false)
               }
            },
               (error) => {
                  if (isMounted) {
                     setError(error);
                     setNeedUpdate(false);
                     appContext.setIsNeedUpdateUnloadingList(false)
                  }
               }
            )
            .catch((error) => {
               if (isMounted) {
                  setError(error);
                  setNeedUpdate(false);
                  appContext.setIsNeedUpdateUnloadingList(false)
               }
            })
      }

      return () => { isMounted = false }

   }, [needUpdate, appContext.isNeedUpdateUnloadingList, type]);

   useEffect(() => {
      if (needUpdate === false) {
         setNeedUpdate(true);
      }
   }, [
      type,
   ]);

   // эффект для применения параметров фильтра
   useEffect(() => {
      if (needUpdate === false) {
         setNeedUpdate(true);
      }
   }, [
      appContext.filter.selectedSorting,
   ]);

   return (
      <Spinner loading={loadingScheduleItem}>

         <UserNotificationMessage />
         <NotificationMessage notifications={notifications} setNeedUpdate={false} setStopListUpdate={setStopListUpdate} loading={loading} />
         {
            data != null && data.TotalCount != 0 &&

            <div className="application-block pagination pagination__up">
               <Pagination
                  style={{ textAlign: "center" }}
                  current={currentPage}
                  pageSize={step}
                  total={data.TotalCount}
                  showTotal={(total, range) => `${range[0]}-${range[1]} из ${data.TotalCount} записей`}
                  onChange={onChange}
               />
            </div>

         }
         {
             data !== null && data.CrossDocks.length > 0 ?
               <CrossDockGroupList items={data.CrossDocks} />
               :
               <CrossDockEmptyContent />
         }
         {
            data != null && data.TotalCount != 0 &&

            <div className="application-block pagination pagination__down">
               <Pagination
                  style={{ textAlign: "center" }}
                  current={currentPage}
                  pageSize={step}
                  total={data.TotalCount}
                  showTotal={(total, range) => `${range[0]}-${range[1]} из ${data.TotalCount} записей`}
                  onChange={onChange}
               />
            </div>
         }

      </Spinner>
   )
}